import React from "react";

type Props = {
  onChange: (e: React.ChangeEvent<HTMLInputElement>, name: string) => void;
  labelStyle?: React.CSSProperties;
  inputStyle?: React.CSSProperties;
  inputMainStyle?: React.CSSProperties;
  noIdForName?: boolean;
  notTiny?: boolean;
  name: string;
  type: string;
  id: string | number;
  min: number;
  max: number;
  value: any;
  label: string;
  disabled?: boolean;
};
const InputNew = ({
  onChange,
  labelStyle = {},
  inputStyle = {},
  inputMainStyle = {},
  noIdForName = false,
  notTiny = false,
  name,
  type,
  id,
  min = 0,
  max = 65536,
  value,
  label,
  disabled = false,
}: Props) => {
  /*let onChange = onChange;
    let labelStyle = {};
    if(typeof labelStyle !== 'undefined'){
        labelStyle = labelStyle;
    }
    let inputStyle = {};
    if(typeof inputStyle !== 'undefined'){
        inputStyle = inputStyle;
    }
    let noIdForName = false;
    if(typeof noIdForName !== 'undefined'){
        noIdForName = noIdForName;
    }*/
  return (
    <>
      {!notTiny ? (
        <>
          <div
            className="inb-form-group column label-float-left medium-12 small-12"
            style={inputMainStyle}
          >
            <label className="inb-form__controlLabel" style={labelStyle}>
              {label}
            </label>
            <div className={"tiny inb-form__controllClass"} style={inputStyle}>
              <input
                className="input "
                id={name + "Input"}
                type={type}
                name={name + (noIdForName ? "" : " " + id)}
                disabled={disabled}
                min={min}
                max={max}
                value={value}
                style={inputStyle}
                placeholder=""
                onChange={(e) => onChange(e, name)}
              />
            </div>
          </div>
        </>
      ) : (
        <>
          <label className="inb-form__controlLabel" style={labelStyle}>
            {label}
          </label>
          <div className={"inb-form__controllClass"} style={inputStyle}>
            <input
              className="input "
              id={name + "Input"}
              type={type}
              name={name + (noIdForName ? "" : " " + id)}
              disabled={disabled}
              value={value}
              min={min}
              max={max}
              style={inputStyle}
              placeholder=""
              onChange={(e) => onChange(e, name)}
            />
          </div>
        </>
      )}
    </>
  );
};

export default InputNew;
